import { render, staticRenderFns } from "./rolePermissionSelect.vue?vue&type=template&id=e676f2fc&scoped=true&"
import script from "./rolePermissionSelect.vue?vue&type=script&lang=js&"
export * from "./rolePermissionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e676f2fc",
  null
  
)

export default component.exports